import React from 'react';
import {
  Center,
  Container,
  Flex,
  Heading,
  Image,
  Text,
  useColorModeValue,
  useMediaQuery,
} from '@chakra-ui/react';
import logo from '../../../assets/images/logo_black.png';
import background from '../../../assets/images/fundo-login.png';
import ResetPasswordForm from '../../../components/forms/ResetPasswordForm';

export function ResetPasswordPage() {
  const [isMobile] = useMediaQuery('(max-width: 767px)');

  return (
    <Flex
      direction={['column', 'row']}
      minH="100vh"
      bg={useColorModeValue('theme.light.body', 'theme.dark.body')}
    >
      {!isMobile && (
        <Flex width="full" minH="100vh" align="center" justify="center">
          <Image maxH="300px" src={logo} alt="Jornada Ser" />
        </Flex>
      )}
      <Center
        width="full"
        minH="100vh"
        backgroundImage={background}
        backgroundSize="cover"
        backgroundPosition="bottom center"
      >
        <Container maxW="420px">
          <Heading fontSize="33px" color="white" mb={2}>
            Criar nova senha
          </Heading>
          <Text color="white" mb={8}>
            Use uma senha forte e diferente das senhas anteriores.
          </Text>
          <ResetPasswordForm />
        </Container>
      </Center>
    </Flex>
  );
}
